import Vue from 'vue'
import App from '../App'
import Router from 'vue-router'
import store from '@/store'

// 各页面都做懒加载
// home和ranking都用到了排行榜组件，所以打包在一个组
const Home = r => require.ensure([], () => r(require('../pages/home')), 'Home')

Vue.use(Router)

const pageName = ' - 金十数据'
const mode = process.env.NODE_ENV === 'test' ? '' : 'history'
const router = new Router({
  routes: [
    {
      path: '/',
      component: App,
      children: [
        {
          path: '/',
          component: Home,
          meta: {
            title: '金十TV直播' + pageName
          }
        },
        {
          path: 'tv',
          component: Home,
          meta: {
            type: 'tv',
            title: '金十TV直播' + pageName
          }
        },
        {
          path: '303ccae79fc4661d',
          component: Home,
          meta: {
            roomID: 16,
            type: '303ccae79fc4661d',
            title: '金十交易学院' + pageName,
            subTitle: '学员专属直播间'
          }
        },
        {
          path: 'xinwenshe',
          component: Home,
          meta: {
            type: 'xinwenshe',
            title: '金十TV直播' + pageName
          }
        },
        {
          path: 'tradingNew',
          component: Home,
          meta: {
            type: 'tradingNew',
            title: '金十同声传译' + pageName
          }
        },
        {
          path: 'fangtan',
          component: Home,
          meta: {
            type: 'fangtan',
            title: '金十TV直播' + pageName
          }
        },
        {
          path: 'tradeCollege',
          component: Home,
          meta: {
            type: 'tradeCollege',
            title: '金十交易学院' + pageName
          }
        },
        {
          path: 'live-nav',
          component: Home,
          meta: {
            type: 'live-nav',
            title: '领航汇' + pageName
          }
        },
        {
          path: 'daka',
          component: Home,
          meta: {
            type: 'daka',
            title: '金十大咖线程' + pageName
          }
        },
        {
          path: 'week8',
          component: Home,
          meta: {
            type: 'week8',
            title: '交易曦游记' + pageName
          }
        },
        {
          path: 'vip',
          component: Home,
          meta: {
            type: 'vip',
            title: 'vip直播'
          }
        },
        {
          path: 'qihuo',
          component: Home,
          meta: {
            type: 'qihuo',
            title: '金十脱水期货 - 金十数据'
          }
        },
        {
          path: 'vTrader',
          component: Home,
          meta: {
            type: 'vTrader',
            title: '超级VIP - 金十数据'
          }
        },
        {
          path: 'gamma',
          component: Home,
          meta: {
            type: 'gamma',
            title: 'GMA伽玛 - 金十数据'
          }
        },
        {
          path: 'gammaPri',
          component: Home,
          meta: {
            type: 'gammaPri',
            title: '金十数据'
          }
        },
        {
          path: 'vip-priv',
          component: Home,
          meta: {
            type: 'vip-priv',
            title: '金十数据'
          }
        },
        {
          path: 'ttps-priv',
          component: Home,
          meta: {
            type: 'ttps-priv',
            title: '金十数据'
          }
        },
        {
          path: 'vipYear',
          component: Home,
          meta: {
            type: 'vipYear',
            title: '金十数据'
          }
        },
        {
          path: 'vipTools',
          component: Home,
          meta: {
            type: 'vipTools',
            title: 'VIP订单流 - 金十数据'
          }
        },
        {
          path: 'live-btnws',
          component: Home,
          meta: {
            type: 'live-btnws',
            title: 'Better News高见 - 金十数据'
          }
        }
        // {
        //   path: 'qh-watch',
        //   component: Home,
        //   meta: {
        //     type: 'qh-watch',
        //     title: '期货盯盘神器 - 金十数据'
        //   }
        // },
        // {
        //   path: 'live-d80',
        //   component: Home,
        //   meta: {
        //     type: 'live-d80',
        //     title: '北辰盯期货 - 金十数据'
        //   }
        // },
        // {
        //   path: 'live-rinly',
        //   component: Home,
        //   meta: {
        //     type: 'live-rinly',
        //     title: 'Rinly实战室 - 金十数据'
        //   }
        // }
      ]
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})
router.beforeEach(async (to, from, next) => {
  if (to.path === '/qh-watch') {
    if (store.state.hasGetDingInfo) {
      if (store.state.hasBuyDing) {
        next()
      } else {
        if (store.state.hasGetDingShowConfig) {
          if (store.state.dingShowConfig.show) {
            next()
          } else {
            next({
              path: '/'
            })
          }
        } else {
          await store.dispatch('getDingShowConfig')
          if (store.state.dingShowConfig.show) {
            next()
          } else {
            next({
              path: '/'
            })
          }
        }
      }
    } else {
      await store.dispatch('getDingInfo')
      if (store.state.hasBuyDing) {
        next()
      } else {
        if (store.state.hasGetDingShowConfig) {
          if (store.state.dingShowConfig.show) {
            next()
          } else {
            next({
              path: '/'
            })
          }
        } else {
          await store.dispatch('getDingShowConfig')
          if (store.state.dingShowConfig.show) {
            next()
          } else {
            next({
              path: '/'
            })
          }
        }
      }
    }
  } else {
    Promise.all([
      store.dispatch('getDingInfo'),
      store.dispatch('getDingShowConfig')
    ]).then(() => {
      next()
    })
  }
})
export default router



// WEBPACK FOOTER //
// ./src/views/tv/router/index.js